import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function homeInfoReducer(state= initialState.homeInfo, action){
	switch(action.type){
		case types.LOAD_HOME_INFO_SUCCESS:
            
			return action.datos;		
	
		default:
			return state;
	}
}